function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire32ca"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire32ca"] = parcelRequire;
}
parcelRequire.register("geL0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd226c24ee4b7195$export$2e2bcd8739ae039);
/**
 * API v3 contains changes to save high scores at the host level.
 * API v4 contains changes for retrieving the referral score from the handshake.
 * API v5 contains changes to retrieve the game save from the handshake.
 * [DEPRECATED] API v6 contains changes for embedded games.
 * API v7 contains changes to support files sharing.
 * API v8 contains changes to support saving the game state at any times.
 * API v9 adds Development mode and changes to games embedding (deprecates v6).
 * API V10 adds a message to trigger feedback dialog.
 * API V11 adds support for SMLG app.
 * API V12 add local dev mode detection (skips handshake).
 * API V13 add close button control for allowlisted experiments.
 * API V14 adds dark mode support in the capabilities.
 * API V15 adds studio messaging.
 */ const $bd226c24ee4b7195$var$API_VERSION = 15;
// Private consts.
/** @const {number} */ const $bd226c24ee4b7195$var$HANDSHAKE_INTERVAL_MS = 500;
/** @const {number} */ const $bd226c24ee4b7195$var$SMLG_HANDSHAKE_INTERVAL_MS = 50;
/** @const {string} */ const $bd226c24ee4b7195$var$CHILD_TO_HOST_HANDSHAKE = "hpi";
/** @const {string} */ const $bd226c24ee4b7195$var$HOST_TO_CHILD_HANDSHAKE = "hpo";
/** @const {number} */ const $bd226c24ee4b7195$var$MAX_STORAGE_BYTES = 32000;
/**
 * Whether we're in development mode. Somewhat obfuscated.
 */ const $bd226c24ee4b7195$var$DEV_MODE = !!window[[
    "_y",
    1
].join(Math.floor(Math.random())) + 0];
/**
 * Whether we're in local + top frame development mode (skips handhsake).
 */ const $bd226c24ee4b7195$var$LOCAL_DEV_MODE = $bd226c24ee4b7195$var$DEV_MODE && document.location.hostname == "localhost" && window.self == window.top;
/**
 * SMLG object if available.
 */ const $bd226c24ee4b7195$var$SMLG = window["__gci_axl"];
/**
 * Checks that the host is a *.google(rs).com or the embed.culturalspot.org
 * domain for embedded games. Private.
 * @param {string} origin
 * @return {boolean}
 */ const $bd226c24ee4b7195$var$isTrustedOrigin = (origin)=>{
    return $bd226c24ee4b7195$var$DEV_MODE || !!$bd226c24ee4b7195$var$SMLG || !!origin.match(/^https?\:\/\/((([\w-]*\.)+google(rs)?\.com)|(embed\.culturalspot\.org))(?:[\/:?#]|$)/i);
};
(function() {
    // Callback placeholder that will wait until document.body is available.
    let afterBodyParsed = ()=>{};
    if ($bd226c24ee4b7195$var$DEV_MODE) {
        const label = "Development mode";
        afterBodyParsed = ()=>{
            const watermarkEl = document.createElement("div");
            watermarkEl.innerText = label;
            const rules = {
                background: "rgba(255,0,0,.75)",
                color: "#fff",
                fontFamily: "Arial",
                fontSize: "12px",
                left: 0,
                padding: "12px",
                position: "fixed",
                top: 0,
                zIndex: 9999
            };
            Object.assign(watermarkEl.style, rules);
            document.body.appendChild(watermarkEl);
        };
        const prefixStyle = "color:teal";
    } else {
        // Agressively kill all console.log outputs.
        window["console"]["log"] = ()=>{};
        afterBodyParsed = ()=>{
            // Hack to detect non-iframe mode and block content.
            if (window.self === window.top && !navigator.userAgent.includes("SMLG")) {
                document.body.textContent = "This experiment is not available on this platform.";
                window.close();
                // Throw to interrupt the app ASAP.
                throw "Experiment unavailable on this platform.";
            }
            // Hack to detect iframing from an unauthorized domain and block content.
            if (document.referrer && document.referrer !== "" && !$bd226c24ee4b7195$var$isTrustedOrigin(document.referrer)) {
                document.body.textContent = "This experiment is not available for embedding.";
                window.close();
                throw "Experiment unavailable for embedding.";
            }
        };
    }
    let observer;
    const check = ()=>{
        if (document.body) {
            afterBodyParsed();
            observer && observer.disconnect();
        }
    };
    observer = new MutationObserver(check);
    observer.observe(document.documentElement, {
        childList: true
    });
    check();
})();
/**
 * @param {*} val
 * @return {number}
 */ const $bd226c24ee4b7195$var$countBytes = (val)=>{
    return new Blob([
        JSON.stringify(val)
    ]).size;
};
/**
 * Test localStorage access. If not available, will issue a console warning and
 * the AxL.storage should still work as a volatile key/value store.
 */ let $bd226c24ee4b7195$var$ls = null;
try {
    $bd226c24ee4b7195$var$ls = window.localStorage;
} catch (e) {}
/**
 * A storage service implementation, currently relying on localStorage. Provides
 * a stable interface to the client, prevents collsions with other clients on
 * the same domain, and enforces quota restrictions. Also supports delegating
 * saving of High Scores to the Host.
 */ class $bd226c24ee4b7195$var$AxLStorage {
    /**
   * @param {string} storageKey
   * @param {function(!AxL.ChildToHost, !Object)} sendMessageCallback
   * @param {number|undefined} initHighScore initial high score supplied by
   *     Stella.
   * @param {number|undefined} referralScore referral score supplied by Stella.
   *     It represents the score of a third-party user that we'd like to beat.
   * @param {!Object|undefined} highScoreData object that represents the high
   *     score data, used to start the game where the user left off. The object
   * must be JSON serializable.
   */ constructor(storageKey, sendMessageCallback, initHighScore, referralScore, highScoreData){
        /** @private @const {string} */ this.storageKey_ = storageKey;
        /** @private {!Map<string, *>} */ this.storageMap_ = new Map();
        /** @private @const {function(!AxL.ChildToHost, !Object)} */ this.sendMessageCallback_ = sendMessageCallback;
        /** @private @const {number|undefined} */ this.referralScore_ = referralScore;
        /** @private {!Object} */ this.currentHighScoreObject_ = {
            "s": initHighScore,
            "d": highScoreData
        };
        // If the high score saving is delegated to Stella and no init high score
        // has been provided, try taking the high score from the local storage.
        if ($bd226c24ee4b7195$var$AxL.can["delegateSaving"] && !initHighScore) {
            const localHighScore = this.getHighScoreInLocalStorage_();
            const localHighScoreNumber = localHighScore["s"];
            if (localHighScoreNumber) this.currentHighScoreObject_["s"] = localHighScoreNumber;
            const localHighScoreData = localHighScore["d"];
            if (localHighScoreData) this.currentHighScoreObject_["d"] = localHighScoreData;
            // If there is actually a local high score number, try saving it along
            // with the data.
            if (localHighScoreNumber !== undefined) // Send a message up to Stella to save this local storage high score in
            // database.
            this.sendMessageCallback_($bd226c24ee4b7195$var$AxL.ChildToHost.SAVE_HIGH_SCORE_FROM_LOCALSTORAGE, this.currentHighScoreObject_);
        }
        this.loadStorage_();
    }
    /**
   * @private
   */ loadStorage_() {
        this.storageMap_ = new Map();
        try {
            const dataObj = JSON.parse($bd226c24ee4b7195$var$ls && $bd226c24ee4b7195$var$ls.getItem(this.storageKey_) || "{}");
            this.storageMap_ = new Map(Object.entries(/** @type {!Object} */ dataObj));
        } catch (e) {}
    }
    /**
   * @private
   */ syncStorage_() {
        if (!$bd226c24ee4b7195$var$ls) return;
        $bd226c24ee4b7195$var$ls.setItem(this.storageKey_ + "#ts", Date.now() + "");
        $bd226c24ee4b7195$var$ls.setItem(this.storageKey_, JSON.stringify(Object.fromEntries(this.storageMap_)));
    }
    /**
   * @param {string} key
   * @return {!Promise<*>}
   * @export
   */ getItem(key) {
        return Promise.resolve(this.storageMap_.get(key));
    }
    /**
   * @param {string} key
   * @param {*} value
   * @return {!Promise<number>}
   * @export
   */ setItem(key, value) {
        return new Promise((resolve, reject)=>{
            try {
                if (this.bytesUsed - $bd226c24ee4b7195$var$countBytes(this.storageMap_.get(key)) + $bd226c24ee4b7195$var$countBytes(value) >= $bd226c24ee4b7195$var$MAX_STORAGE_BYTES) {
                    reject(new Error("Storage quota exceeded"));
                    return;
                }
                this.storageMap_.set(key, value);
                this.syncStorage_();
                resolve(this.usage);
            } catch (e) {
                reject(e);
            }
        });
    }
    /**
   * @param {string} key
   * @return {!Promise<number>}
   * @export
   */ removeItem(key) {
        return new Promise((resolve, reject)=>{
            this.storageMap_.delete(key);
            this.syncStorage_();
            resolve(this.usage);
        });
    }
    /**
   * Public exported method to save a new high score.
   * @param {number} score
   * @param {!Object=} optionalData extra state to save along with the high
   *     score to be able to continue where the user left off.
   * @param {!AxL.ScoreUnit=} scoreUnit Unit to represent the score (number of
   *     points, time, etc). Defaults to a number.
   * @param {boolean=} lowerScoreIsBetter whether or not a lower score is going
   *     to be considered better. Defaults to false.
   * @return {!Promise<number>}
   * @export
   */ setHighScore(score, optionalData, scoreUnit = $bd226c24ee4b7195$var$AxL.ScoreUnit.POINTS, lowerScoreIsBetter = false) {
        const scoreObj = {
            "s": score,
            "d": optionalData,
            "u": scoreUnit,
            "lb": lowerScoreIsBetter
        };
        // If we should delegate saving, we send an message up to the host.
        if ($bd226c24ee4b7195$var$AxL.can["delegateSaving"]) {
            // Save the new high score object.
            this.currentHighScoreObject_ = scoreObj;
            return new Promise((resolve, reject)=>{
                this.sendMessageCallback_($bd226c24ee4b7195$var$AxL.ChildToHost.SAVE_HIGH_SCORE, scoreObj);
                // TODO(dcamilleri): add a handshake to set the high score in the local
                // storage in case storing with the host failed.
                resolve();
            });
        }
        return new Promise((resolve, reject)=>{
            if (!$bd226c24ee4b7195$var$ls) {
                reject(new Error("Storage not available"));
                return;
            }
            try {
                if (this.bytesUsed - $bd226c24ee4b7195$var$countBytes($bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#hs")) + $bd226c24ee4b7195$var$countBytes(scoreObj) >= $bd226c24ee4b7195$var$MAX_STORAGE_BYTES) {
                    reject(new Error("Storage quota exceeded"));
                    return;
                }
                const localHighScore = this.getHighScoreInLocalStorage_();
                // If the new score isn't better than the old one (based on the
                // scoreUnit provided, or the default one), let's reject that request.
                switch(scoreUnit){
                    case $bd226c24ee4b7195$var$AxL.ScoreUnit.POINTS:
                    case $bd226c24ee4b7195$var$AxL.ScoreUnit.PERCENTAGE:
                        if (score <= localHighScore["s"]) {
                            reject(new Error("Not highest score."));
                            return;
                        }
                        break;
                    case $bd226c24ee4b7195$var$AxL.ScoreUnit.TIME_MILLIS:
                        if (score >= localHighScore["s"]) {
                            reject(new Error("Not highest score."));
                            return;
                        }
                        break;
                    default:
                        break;
                }
                $bd226c24ee4b7195$var$ls.setItem(this.storageKey_ + "#ts", Date.now() + "");
                $bd226c24ee4b7195$var$ls.setItem(this.storageKey_ + "#hs", JSON.stringify(scoreObj));
                resolve(this.usage);
            } catch (e) {
                reject(e);
            }
        });
    }
    /**
   * Public exported method to save a game state at any point in the game.
   * @param {!Object} gameStateObject state object to save to be able to
   *     continue where the user left off. Can contain any info related to the
   * game, eg the current level, which artwork the user has unlocked, etc.
   * @return {!Promise<undefined>}
   * @export
   */ setGameState(gameStateObject) {
        if (!$bd226c24ee4b7195$var$AxL.can["delegateSaving"]) return Promise.reject("Can't save Game State");
        // If we should delegate saving, we send an message up to the host.
        // Store the new game state into the global high score object.
        this.currentHighScoreObject_["d"] = gameStateObject;
        return new Promise((resolve, reject)=>{
            this.sendMessageCallback_($bd226c24ee4b7195$var$AxL.ChildToHost.SAVE_GAME_STATE, gameStateObject);
            resolve();
        });
    }
    /**
   * If saving of high scores is delegated to Stella, returns the initial game
   * state data provided by the handshake or any new state that has been
   * saved since. This data is stored in the global high score object.
   * @return {!Promise<?Object>}
   * @export
   */ getGameState() {
        if (!$bd226c24ee4b7195$var$AxL.can["delegateSaving"]) return Promise.reject("Can't get Game State");
        return Promise.resolve(this.currentHighScoreObject_["d"]);
    }
    /**
   * Retrieves the high score from the local storage.
   * @private
   * @return {!Object}
   */ getHighScoreInLocalStorage_() {
        return /** @type {!Object} */ JSON.parse($bd226c24ee4b7195$var$ls && $bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#hs") || "{}");
    }
    /**
   * Public method to retrieve the user's high score. High score is retrieved:
   * - From ContribService through Stella if the Stella high score integration
   * is launched.
   * - From a local storage otherwise.
   * @return {!Promise<?number>}
   * @export
   */ getHighScore() {
        // If saving of high scores is delegated to Stella, return the initial high
        // score provided or any new score that has been saved since.
        if ($bd226c24ee4b7195$var$AxL.can["delegateSaving"]) return Promise.resolve(this.currentHighScoreObject_["s"]);
        // Otherwise take the score from the local storage.
        const scoreObj = this.getHighScoreInLocalStorage_();
        return Promise.resolve(scoreObj["s"]);
    }
    /**
   * Public method to retrieve the referral score. This data is supplied during
   * the handshake.
   * @return {!Promise<number|undefined>}
   * @export
   */ getReferralScore() {
        return Promise.resolve(this.referralScore_);
    }
    /**
   * @return {!Promise<undefined>}
   * @export
   */ flush() {
        if ($bd226c24ee4b7195$var$ls) {
            $bd226c24ee4b7195$var$ls.removeItem(this.storageKey_);
            $bd226c24ee4b7195$var$ls.removeItem(this.storageKey_ + "#ts");
            $bd226c24ee4b7195$var$ls.removeItem(this.storageKey_ + "#hs");
        }
        this.storageMap_ = new Map();
        return Promise.resolve();
    }
    /**
   * @return {number}
   * @export
   */ get lastChange() {
        if (!$bd226c24ee4b7195$var$ls) return -1;
        let ts = $bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#ts");
        return ts ? parseInt($bd226c24ee4b7195$var$ls.getItem(this.storageKey_ + "#ts"), 10) : Date.now();
    }
    /**
   * @return {number}
   */ get bytesUsed() {
        if (!$bd226c24ee4b7195$var$ls) return 0;
        const keys = Object.keys($bd226c24ee4b7195$var$ls || {}).filter((key)=>key.includes(this.storageKey_));
        const values = keys.map((key)=>$bd226c24ee4b7195$var$ls[key]);
        return new Blob(keys).size + new Blob(values).size;
    }
    /**
   * @return {number}
   * @export
   */ get usage() {
        return this.bytesUsed / $bd226c24ee4b7195$var$MAX_STORAGE_BYTES;
    }
    /**
   * @return {boolean}
   * @export
   */ get isLocalStorage() {
        return !!$bd226c24ee4b7195$var$ls;
    }
}
class $bd226c24ee4b7195$var$AxL {
    constructor(hostWindow = window.parent){
        /** @private @const {!Window} */ this.hostWindow_ = hostWindow;
        /** @private {?string} */ this.hostOrigin_ = null;
        /** @private @const {!Map<!AxL.HostToChild, !Function>} */ this.callbacks_ = new Map();
        /** @private {?Function} */ this.boundMessageHandler_ = null;
        /** @export {?AxLStorage} */ this.storage = null;
        const defaultHandshakeInterval = !!$bd226c24ee4b7195$var$SMLG ? $bd226c24ee4b7195$var$SMLG_HANDSHAKE_INTERVAL_MS : $bd226c24ee4b7195$var$HANDSHAKE_INTERVAL_MS;
        const params = new URLSearchParams(window.location.search);
        const hiOverrideParam = !!$bd226c24ee4b7195$var$SMLG ? "axlshi" : "axlhi";
        /** @private @const {number} */ this.handshakeInterval_ = parseInt(params.get(hiOverrideParam), 10) || defaultHandshakeInterval;
    }
    /**
   * Pings the host every 1000ms and returns a Promise that resolves when the
   * host responds. Call this when the app is ready to go.
   * @return {!Promise<!Object>}
   * @export
   */ handshake() {
        if ($bd226c24ee4b7195$var$LOCAL_DEV_MODE) return Promise.resolve({});
        let interval;
        const promise = new Promise((resolve, reject)=>{
            const handleGetResponse = (e)=>{
                if (!$bd226c24ee4b7195$var$isTrustedOrigin(e["origin"])) return;
                if (!e["data"] || e["data"]["type"] != $bd226c24ee4b7195$var$HOST_TO_CHILD_HANDSHAKE) return;
                try {
                    clearInterval(interval);
                    this.hostOrigin_ = e["origin"] || "*";
                    this.boundMessageHandler_ = (event)=>{
                        this.handleIncomingMessage_(event);
                    };
                    window.addEventListener("message", this.boundMessageHandler_);
                    window.removeEventListener("message", handleGetResponse);
                    // Retrieving system data.
                    const sysCmd = e["data"]["sys"];
                    if (e["data"]["id"]) {
                        const storageSendMessageCallback = (childToHostMessageType, payload)=>{
                            this.sendMessage(childToHostMessageType, payload);
                        };
                        let initHighScore = undefined;
                        let referralScore = undefined;
                        let highScoreData = undefined;
                        // Handling high scores data supplied by Stella in the system data.
                        if (sysCmd) {
                            $bd226c24ee4b7195$var$AxL.can["delegateSaving"] = !!sysCmd["ds"];
                            initHighScore = sysCmd["hs"];
                            referralScore = sysCmd["rs"];
                            highScoreData = sysCmd["hsd"];
                        }
                        this.storage = new $bd226c24ee4b7195$var$AxLStorage(e["data"]["id"], storageSendMessageCallback, initHighScore, referralScore, highScoreData);
                    }
                    if (sysCmd) {
                        if (sysCmd["fb"] && this.storage.lastChange < sysCmd["fb"]) this.storage.flush();
                        const capabilities = sysCmd["c"];
                        if (capabilities) {
                            $bd226c24ee4b7195$var$AxL.can["shareFiles"] = !!capabilities["sf"];
                            $bd226c24ee4b7195$var$AxL.can["download"] = !!capabilities["d"];
                            $bd226c24ee4b7195$var$AxL.can["useAltIcon"] = !!capabilities["uai"];
                            $bd226c24ee4b7195$var$AxL.can["sendFeedback"] = !!capabilities["f"];
                            $bd226c24ee4b7195$var$AxL.can["toggleExitButton"] = !!capabilities["te"];
                            $bd226c24ee4b7195$var$AxL.can["preferDarkMode"] = !!capabilities["dme"];
                        }
                    }
                    resolve(e["data"]["payload"]);
                } catch (error) {
                    reject(error);
                }
            };
            window.addEventListener("message", handleGetResponse);
        });
        interval = setInterval(()=>{
            this.sendMessage($bd226c24ee4b7195$var$CHILD_TO_HOST_HANDSHAKE, {
                "v": $bd226c24ee4b7195$var$API_VERSION
            });
        }, this.handshakeInterval_);
        return promise;
    }
    /**
   * Public method to send messages to the host along with optional data.
   * @param {!AxL.ChildToHost|string} childToHostMessageType
   * @param {?Object=} payload
   * @export
   */ sendMessage(childToHostMessageType, payload = null) {
        if (!this.hostOrigin_ && childToHostMessageType != $bd226c24ee4b7195$var$CHILD_TO_HOST_HANDSHAKE) return;
        const message = {
            "type": childToHostMessageType,
            "payload": payload
        };
        if (!!$bd226c24ee4b7195$var$SMLG) $bd226c24ee4b7195$var$SMLG.postMessage(JSON.stringify(message));
        else this.hostWindow_.postMessage(message, this.hostOrigin_ || "*");
    }
    /**
   * Removes the incoming messages listener, clears any registered callback
   * and breaks the handshake.
   * @export
   */ dispose() {
        this.hostOrigin_ = null;
        this.boundMessageHandler_ && window.removeEventListener("message", this.boundMessageHandler_);
        this.callbacks_.clear();
    }
    /**
   * Registers a callback upon receiving a given Host message.
   * @param {!AxL.HostToChild} hostToChildMessageType
   * @param {!Function} callback
   * @export
   */ registerMessageCallback(hostToChildMessageType, callback) {
        this.callbacks_.set(hostToChildMessageType, callback);
    }
    /**
   * Private handler method for incoming messages.
   * @param {!Event} event
   * @private
   */ handleIncomingMessage_(event) {
        if (!$bd226c24ee4b7195$var$isTrustedOrigin(event["origin"])) return;
        if (!event["data"]) return;
        const callback = this.callbacks_.get(event["data"]["type"]);
        callback && callback(event["data"]["payload"]);
    }
}
/**
 * Indicates the framework and device capabilities. This is actually populated
 * when the handshake is completed.
 * @const {!Object<string, boolean>}
 */ $bd226c24ee4b7195$var$AxL.can = {
    "shareFiles": false,
    // Whether the SHARE message can accept files.
    "download": false,
    // Whether file download is supported on the platform.
    "useAltIcon": false,
    // True for iOS, for using appropriate share icons.
    "delegateSaving": false,
    // Whether saving data should be delegated to Stella.
    "sendFeedback": false,
    // True if the GAC feedback feature is available.
    "toggleExitButton": false,
    // True if the experiment can hide the exit button.
    "preferDarkMode": false // True if the sandboxer prefers that the UI is
};
// List of valid message types. Should match those defined by Stella.
/**
 * Events sent from the child (eg the game) to the host (eg Stella) of the
 * iframe.
 * @enum {string}
 */ $bd226c24ee4b7195$var$AxL.ChildToHost = {
    "FEEDBACK": "f",
    "NAVIGATE": "n",
    "SET_URL_PARAMS": "p",
    "SHARE": "s",
    "TOGGLE_EXIT_BUTTON": "te",
    "TRACK": "t",
    "SAVE_HIGH_SCORE": "hs",
    "SAVE_HIGH_SCORE_FROM_LOCALSTORAGE": "hsl",
    "SAVE_GAME_STATE": "gs",
    "STUDIO_ACTION": "sa"
};
/**
 * Events sent from the host of the iframe (eg Stella) to the child (eg the
 * game).
 * @enum {string}
 */ $bd226c24ee4b7195$var$AxL.HostToChild = {
    "FREEZE": "f",
    "RESUME": "r",
    "STUDIO_ACTION": "sa"
};
/**
 * Representation of the unit of the game's score.
 * @enum {string}
 */ $bd226c24ee4b7195$var$AxL.ScoreUnit = {
    // Score represents an integer number of points.
    "POINTS": "p",
    // Score represents a time in milliseconds.
    "TIME_MILLIS": "tm",
    // Score represents a percentage of completion.
    "PERCENTAGE": "pc"
};
/** @const {number} */ $bd226c24ee4b7195$var$AxL.v = $bd226c24ee4b7195$var$API_VERSION;
var $bd226c24ee4b7195$export$2e2bcd8739ae039 = $bd226c24ee4b7195$var$AxL;

});

parcelRequire.register("gL5u8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3354a5852f3cef7$export$2e2bcd8739ae039);

var $geL0V = parcelRequire("geL0V");

var $edfmO = parcelRequire("edfmO");

var $aJPda = parcelRequire("aJPda");

var $fAX6M = parcelRequire("fAX6M");
const $c3354a5852f3cef7$var$LIGHTNESS = "42%";
const $c3354a5852f3cef7$var$LIGHTNESS_BUTTON = "25%";
const $c3354a5852f3cef7$var$BACKGROUND_ALPHA = "0.359375";
const $c3354a5852f3cef7$var$CS_DEBUG = false;
/**
 * Whether the user is in Culture Studio.
 */ const $c3354a5852f3cef7$var$isCultureStudio = window.navigator.userAgent.toLowerCase().includes("culturestudio");
const $c3354a5852f3cef7$var$isiOSWebview = window.navigator.userAgent.toLowerCase().includes("ioswebview");
class $c3354a5852f3cef7$export$2e2bcd8739ae039 {
    constructor(){
        this.assetsMap = new Map();
        this.artworkImg = document.getElementById("artwork-img");
        this.poem = document.getElementById("poem");
        this.backToEdit = document.getElementById("back-to-edit");
        this.poemAttribution = document.getElementById("poem-attribution");
        this.generateButton = document.getElementById("generate-button");
        this.poemTypeSelect = document.getElementById("poem-type-select");
        this.toneInput = document.getElementById("tone-input");
        this.toneWarning = document.getElementById("tone-warning");
        this.studioShareButton = document.getElementById("studio-share-button");
        this.studioSaveButton = document.getElementById("studio-save-button");
        this.shareRewrite = document.getElementById("share-rewrite");
        this.studioShareRewrite = document.getElementById("studio-share-rewrite");
        this.rewriteButton = document.getElementById("rewrite-button");
        this.studioRewriteButton = document.getElementById("studio-rewrite-button");
        this.moreArtButton = document.getElementById("more-artworks-button");
        this.shareMoreArtButton = document.getElementById("share-more-artworks-button");
        this.selectArtworkButton = document.getElementById("select-artwork-button");
        this.stampAmpersand = document.getElementById("stamp-ampersand");
        this.stampAmpersandMobile = document.getElementById("stamp-ampersand-mobile");
        this.poemErrorMessage = document.getElementById("poem-error-message");
        this.closePoemErrorButton = document.getElementById("poem-error-message-close-button");
        this.poemCleaned = "";
        this.dominantColor = "";
        this.loadArtworksStatus = "notloaded";
        this.shareCardMaker = new (0, $aJPda.default)();
        this.generatingPoem = false;
        this.supportsWebp = false;
        this.uuid = "";
        if ($c3354a5852f3cef7$var$isCultureStudio) {
            // Lets stylesheets adapt to the Culture Studio host (e.g. its header).
            document.body.classList.add("culture-studio");
            this.shareRewrite.style.display = "none";
            if ($c3354a5852f3cef7$var$isiOSWebview) {
                // Change the share icon to iOS share icon.
                let shareButton = document.getElementById("studio-share-button");
                let iconElement = shareButton.querySelector(".material-symbols-outlined");
                iconElement.innerText = "ios_share";
            }
        } else this.studioShareRewrite.style.display = "none";
    }
    // starts loading the more artworks assets
    preload() {
        this.setPoemTypeSelectionsUi();
    }
    async loadMoreArtworks() {
        this.loadArtworksStatus = "loading";
        let loadingContainer = document.getElementById("more-artworks-loading-container");
        loadingContainer.classList.remove("hidden");
        document.getElementById("more-artworks-loading-spinner").classList.add("spinner");
        document.getElementById("more-artworks-loading-error").classList.add("hidden");
        // Only fetch data and bind event handlers if we didn't get assets from a previous
        // call to this method.
        if (!this.moreArtworksLoaded) {
            let assetsData;
            try {
                assetsData = await this.fetchAssets(this.allAssets);
            } catch (error) {
                this.onMoreArtworksLoadError();
                return;
            }
            if (assetsData.hasOwnProperty("error")) {
                this.onMoreArtworksLoadError();
                return;
            }
            // load data
            assetsData.items.forEach((item, i)=>{
                this.assetsMap.set(item.id, item);
            });
            //---------- Add artworks to ui
            this.setMoreArtworks();
            // --------- Setup pagination
            const paginationList = document.querySelectorAll(".pagination");
            for (const pagination of paginationList){
                pagination.classList.remove("hidden");
                const paginationButtons = pagination.querySelectorAll(".pagination-button");
                for (const paginationButton of paginationButtons)paginationButton.addEventListener("click", this.onPaginationButtonClick.bind(this));
            }
            //---- request dominant colors for all artworks
            this.fetchAllColors();
            this.moreArtworksLoaded = true;
        }
        // enable ui
        document.getElementById("select-artwork-button").classList.add("show");
        this.loadArtworksStatus = "loaded";
    }
    async initAxl(axl, initialData, restricted = false) {
        this.axl = axl;
        const queryParams = new URLSearchParams(window.location.search);
        this.assetId = initialData.assetId || this.allAssets[Math.floor(Math.random() * this.allAssets.length)]; // Fall back to random asset.
        // Tracking
        this.axl.sendMessage((0, $geL0V.default).ChildToHost.TRACK, {
            action: "experiment load",
            category: "websandbox_ZgG5_uTbBgTpIQ",
            label: this.assetId || "unset"
        });
        await this.setSupportsWebp();
        this.setAssetImage();
        this.dominantColor = (await this.fetchDominantColor(this.assetId)).dominant_color;
        this.setDominantColor(this.dominantColor);
        this.axl.registerMessageCallback((0, $geL0V.default).HostToChild.STUDIO_ACTION, (payload)=>{
            const command = payload["c"];
            if (command == "sa") {
                const newAssetId = payload["a"];
                if (newAssetId != null) this.onSwitchArtworkFromHost(newAssetId);
            }
        });
        const poemFromParams = initialData;
        if (poemFromParams.hasOwnProperty("uuid")) {
            this.createShareablePostcard(poemFromParams, restricted);
            return;
        }
    }
    async init(data, axl) {
        this.allAssets = await this.getAllAssets();
        this.poemCleaned = "";
        // Event listeners
        this.toneInput.addEventListener("keydown", this.onToneInputKeyDown);
        this.generateButton.addEventListener("click", this.onGenerateButtonClicked);
        this.rewriteButton.addEventListener("click", this.onBackToEditButtonClicked);
        this.studioRewriteButton.addEventListener("click", this.onBackToEditButtonClicked);
        this.backToEdit.addEventListener("click", this.onBackToEditButtonClicked);
        this.initShared();
        this.moreArtButton.addEventListener("click", this.onMoreArtworksButtonClicked);
        this.shareMoreArtButton.addEventListener("click", this.onMoreArtworksButtonClicked);
        this.selectArtworkButton.addEventListener("click", (function() {
            this.onSelectedNewArtwork();
        }).bind(this));
        this.poemTypeSelect.addEventListener("click", (function(e) {
            this.showPage("poem-type-select-page");
            const poemType = document.querySelector("#poem-type-selected-name").getAttribute("data-value");
            const selectionEl = document.querySelector(`.poem-type-selection[data-value="${poemType}"]`).parentNode.parentNode;
            if (selectionEl) this.setExpanded(selectionEl, e);
        }).bind(this));
        this.closePoemErrorButton.addEventListener("click", (function(e) {
            this.poemErrorMessage.classList.add("hidden");
        }).bind(this));
        document.getElementById("create-new-button").addEventListener("click", (function(e) {
            this.onBackToEditButtonClicked(e);
        }).bind(this));
        window.addEventListener("resize", (function() {
            this.resizeImage();
        }).bind(this));
        document.querySelector("#artwork-poem-view-cover-nav-rewrite").addEventListener("click", (function() {
            this.onBackToEditButtonClicked();
        }).bind(this));
        let backToPageButtons = document.querySelectorAll(".back-to-page");
        backToPageButtons.forEach((button, i)=>{
            button.addEventListener("click", (function() {
                this.showPage(this.prevPage.getAttribute("id"));
            }).bind(this));
        });
        let backToEditButtons = document.querySelectorAll(".back-to-edit");
        backToEditButtons.forEach((button, i)=>{
            button.addEventListener("click", (function() {
                this.onBackToEditButtonClicked();
            }).bind(this));
        });
        // links
        let axlLinks = document.querySelectorAll("span.clickable");
        let wikipediaLinks = document.querySelectorAll(".clickable.wikipedia-link");
        [
            ...axlLinks,
            ...wikipediaLinks
        ].forEach((link, i)=>{
            link.addEventListener("click", (function(e) {
                let url = e.currentTarget.getAttribute("data-url");
                if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.NAVIGATE, url);
            }).bind(this));
        });
        // ---o Popins
        const buttonPopinList = document.querySelectorAll(".button-popin");
        buttonPopinList.forEach((buttonPopin)=>{
            buttonPopin.addEventListener("click", (e)=>{
                const targetPopin = e.currentTarget.getAttribute("data-target");
                document.querySelector(`.popin#${targetPopin}`).classList.add("active");
            });
        });
        const buttonPopinCloseList = document.querySelectorAll(".button-popin-close");
        buttonPopinCloseList.forEach((buttonPopinClose)=>{
            buttonPopinClose.addEventListener("click", (e)=>{
                const targetPopin = e.currentTarget.closest(".popin");
                targetPopin.classList.remove("active");
            });
        });
        const popinList = document.querySelectorAll(".popin");
        popinList.forEach((popin)=>{
            popin.addEventListener("click", (e)=>{
                if (e.target.className === "popin active") e.target.classList.remove("active");
            });
        });
        let buttonsWithColor = document.querySelectorAll(".ripple-button");
        buttonsWithColor.forEach((button, i)=>{
            button.addEventListener("click", this.onButtonClick);
        });
        if ($fAX6M()) document.getElementById("landscape-lock-screen").classList.add("show");
        document.getElementById("poem-loading-cancel").addEventListener("click", (function() {
            this.cancelPoemLoading();
        }).bind(this));
        this.studioSaveButton.addEventListener("click", (function(e) {
            this.savePoem(e);
        }).bind(this));
        this.preload();
        if (!!window["_surgeMode"]) this.showMessage("popular");
    }
    async initShared() {
        let shareButtons = document.querySelectorAll("[data-target='share']");
        shareButtons.forEach((button, i)=>{
            button.addEventListener("click", this.onShareButtonClicked);
        });
        document.querySelector(".poem-back-to-cover").addEventListener("click", (function() {
            this.showPage("artwork-cover");
        }).bind(this));
        document.querySelector("#artwork-poem-view-cover-nav-show").addEventListener("click", (function() {
            this.showPage("poem-view-page");
        }).bind(this));
        this.configureCaptionLinks();
    }
    async initRestricted(axl, initialData) {
        this.axl = axl;
        if (window.navigator.userAgent.includes("SMLGWebView")) document.getElementById("goto-arts-button").classList.add("hidden");
        else document.getElementById("goto-arts-button").addEventListener("click", (function() {
            if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.NAVIGATE, "https://artsandculture.google.com");
        }).bind(this));
        const queryParams = new URLSearchParams(window.location.search);
        this.assetId = initialData.assetId || "bgEuwDxel93-Pg"; // Fall back to Starry Night
        this.setAssetImage();
        this.configureCaptionLinks();
        this.dominantColor = (await this.fetchDominantColor(this.assetId)).dominant_color;
        this.setDominantColor(this.dominantColor);
    }
    //---- set main artowrk and captions
    async resizeImage() {
        if (this.assetId) {
            const artworkDetails = await this.fetchArtworkDetails(this.assetId);
            if (artworkDetails) {
                let imageUrl = this.getFifeCropUrl(artworkDetails.image.url, this.artworkImg);
                this.tempImage = new Image();
                await this.loadImageToElement(imageUrl, this.tempImage).catch((function() {
                    this.tempImage = null;
                }).bind(this));
                if (this.tempImage != null) this.artworkImg.src = this.tempImage.src;
            }
        }
    }
    async setAssetImage() {
        const artworkDetails = await this.fetchArtworkDetails(this.assetId);
        this.setImageCaptions(this.assetId, artworkDetails);
        let imageUrl = this.getFifeCropUrl(artworkDetails.image.url, this.artworkImg);
        await this.loadImageToElement(imageUrl, this.artworkImg);
        this.artworkImg.classList.remove("hide");
        let poemViewSection = document.getElementById("poem-view-section-background");
        if (poemViewSection) poemViewSection.style.backgroundImage = "url(" + this.artworkImg.src + ")";
        let artworkCoverBG = document.getElementById("artwork-cover-background");
        if (artworkCoverBG) artworkCoverBG.style.backgroundImage = "url(" + this.artworkImg.src + ")";
        await this.shareCardMaker.storeImageForShareable(this.assetId, artworkDetails.image.url);
    }
    configureCaptionLinks() {
        const captionLinkEls = document.querySelectorAll(".caption-title");
        captionLinkEls.forEach((item, i)=>{
            item.addEventListener("click", (function(e) {
                const assetId = e.currentTarget.getAttribute("data-assetId");
                if (assetId) {
                    const captionUrl = `asset/${assetId}`;
                    if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.NAVIGATE, captionUrl);
                }
            }).bind(this));
        });
    }
    getFifeCropUrl(base_url, el) {
        let bb = el.parentNode.getBoundingClientRect();
        let w = Math.floor(el.width * 1.5);
        let h = Math.floor(el.height * 1.5);
        let requestWebp = this.supportsWebp ? "-rw" : "";
        return base_url + `=w${w}-h${h}-dc${requestWebp}-v1`;
    }
    setImageCaptions(assetId, artworkDetails) {
        let titles = document.querySelectorAll(".caption-title");
        let partners = document.querySelectorAll(".caption-partner");
        let authors = document.querySelectorAll(".caption-artist");
        titles.forEach((item, i)=>{
            item.innerText = artworkDetails.title;
            item.setAttribute("data-assetId", assetId);
        });
        authors.forEach((item, i)=>{
            if (artworkDetails.creators.length > 0) item.innerText = artworkDetails.creators[0].title;
            else item.innerText = "";
        });
        partners.forEach((item, i)=>{
            item.innerText = artworkDetails.partner;
        });
    }
    async loadImageToElement(src, img) {
        return new Promise((resolve, reject)=>{
            // let img = document.getElementById("painting-img");
            img.onload = ()=>resolve();
            img.onerror = reject;
            img.src = src;
        });
    }
    setSupportsWebp = async ()=>{
        const img = new Image();
        const BASE64_LOSSY_WEBP = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        return new Promise((resolve, reject)=>{
            img.onload = ()=>{
                this.supportsWebp = img.width > 0 && img.height > 0;
                resolve();
            };
            img.onerror = ()=>{
                this.supportsWebp = false;
                reject();
            };
            img.src = BASE64_LOSSY_WEBP;
        });
    };
    //------- Set Ui
    setPoemTypeSelectionsUi() {
        let buttons = document.querySelectorAll(".poem-type-more");
        buttons.forEach((buttonEl, i)=>{
            buttonEl.addEventListener("click", (function(e) {
                let grandparent = e.currentTarget.parentNode.parentNode;
                this.toggleExpanded(grandparent, e);
            }).bind(this));
        });
        let containers = document.querySelectorAll(".poem-type-selection");
        containers.forEach((containerEl, i)=>{
            containerEl.addEventListener("click", (function(e) {
                this.toggleExpanded(e.currentTarget.parentNode.parentNode, e);
            // this.setExpanded(e.currentTarget);
            }).bind(this));
        });
        let expandeds = document.querySelectorAll('[data-target="poem-type-select"]');
        expandeds.forEach((expandEl, i)=>{
            expandEl.addEventListener("click", (function(e) {
                let parent = e.currentTarget.parentNode.parentNode;
                document.getElementById("poem-type-selected-name").setAttribute("data-value", parent.getAttribute("data-value"));
                document.getElementById("poem-type-selected-name").setAttribute("data-loading-text", parent.getAttribute("data-loading-text"));
                document.getElementById("poem-type-selected-name").innerText = parent.getAttribute("data-name");
                this.showPage("main-content-view");
            }).bind(this));
        });
    }
    toggleExpanded(el, event) {
        event.stopPropagation();
        if (el.classList.contains("expanded")) el.classList.remove("expanded");
        else this.setExpanded(el);
    }
    setExpanded(el) {
        if (el.classList.contains("expanded")) return;
        let currExpand = document.querySelectorAll("#poem-types-list .expanded");
        currExpand.forEach((item, i)=>{
            item.classList.remove("expanded");
        });
        el.classList.add("expanded");
    // el.firstChid.classList.add("expanded");
    }
    //--- utils
    isMobilePortrait() {
        if (window.innerWidth < window.innerHeight && window.innerWidth < 920) return true;
        return false;
    }
    sanitizeUserInput(text) {
        return text.replace(/[^a-zA-Z0-9\s\.]+/g, "");
    }
    //------- More Artworks
    setMoreArtworks() {
        let parent = document.querySelector("#more-artworks .pagination-target");
        for (let [assetId, assetData] of this.assetsMap)if (Object.keys(assetData).length > 0) {
            let li = document.createElement("li");
            let imgDiv = document.createElement("div");
            const fifeResizedUrl = assetData.image.url.replace("s1200", "h150-c-w150");
            imgDiv.setAttribute("data-src", fifeResizedUrl);
            let artworkLabel = assetData.title;
            if (assetData.creators.length > 0) artworkLabel += ", " + assetData.creators[0].title;
            imgDiv.setAttribute("aria-label", artworkLabel);
            imgDiv.setAttribute("tabindex", 0);
            imgDiv.classList.add("img");
            li.appendChild(imgDiv);
            li.setAttribute("data-assetid", assetId);
            parent.appendChild(li);
            li.addEventListener("click", (e)=>{
                this.showMoreArtwork(e.currentTarget.getAttribute("data-assetid"));
            });
            // this.loadImages(li);
            if (parent.children.length === 1 && !this.isMobilePortrait()) this.showMoreArtwork(assetId);
        }
        this.loadImages(parent);
        let loading = document.querySelectorAll(".more-artworks-loading");
        loading.forEach((item, i)=>{
            item.classList.add("hidden");
        });
    }
    onMoreArtworksLoadError() {
        this.loadArtworksStatus = "error";
        let loadingContainer = document.getElementById("more-artworks-loading-container");
        loadingContainer.classList.add("hidden");
        document.getElementById("more-artworks-loading-spinner").classList.remove("spinner");
        document.getElementById("more-artworks-loading-error").classList.remove("hidden");
    }
    onPaginationButtonClick(e) {
        const parent = e.currentTarget.parentNode;
        const pages = parent.querySelectorAll("li");
        const currentPage = e.currentTarget.parentNode.querySelector("li.active");
        const currentPageIndex = parseInt(currentPage.innerText);
        const lastPageIndex = parseInt(pages[pages.length - 1].innerText);
        const isPrev = e.currentTarget.classList.contains("pagination-button-prev");
        if (isPrev && currentPageIndex === 1 || !isPrev && currentPageIndex === lastPageIndex) return;
        const newIndex = currentPageIndex + (isPrev ? -1 : 1);
        currentPage.classList.remove("active");
        pages[newIndex - 1].classList.add("active");
        const buttonPrev = parent.querySelector(".pagination-button-prev");
        const buttonNext = parent.querySelector(".pagination-button-next");
        if (newIndex > 1 && buttonPrev.classList.contains("disabled")) buttonPrev.classList.remove("disabled");
        else if (newIndex === 1 && !buttonPrev.classList.contains("disabled")) buttonPrev.classList.add("disabled");
        if (newIndex < lastPageIndex && buttonNext.classList.contains("disabled")) buttonNext.classList.remove("disabled");
        else if (newIndex === lastPageIndex && !buttonNext.classList.contains("disabled")) buttonNext.classList.add("disabled");
        const target = parent.parentNode.querySelector(".pagination-target");
        target.setAttribute("data-page", newIndex - 1);
        this.loadImages(target);
    }
    async onSwitchArtworkFromHost(assetId) {
        this.assetId = assetId;
        this.handleSwitchingArtwork();
    }
    async onSelectedNewArtwork() {
        const activeEl = document.querySelector("#more-artworks .active");
        this.assetId = activeEl.getAttribute("data-assetid");
        this.handleSwitchingArtwork();
    }
    async handleSwitchingArtwork() {
        if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.TRACK, {
            action: "click artwork",
            label: this.assetId
        });
        this.artworkImg.classList.add("hide");
        const artworkDetails = await this.fetchArtworkDetails(this.assetId);
        if (artworkDetails["dominantColor"] != null) {
            this.dominantColor = artworkDetails["dominantColor"];
            this.setDominantColor(this.dominantColor);
        } else {
            let assetId = this.assetId;
            let dColor = (await this.fetchDominantColor(assetId)).dominant_color;
            this.assetsMap.set(assetId, {
                ...this.assetsMap.get(assetId),
                dominantColor: dColor
            });
            if (this.assetId == assetId) this.setDominantColor(dColor);
        // this.dominantColor = (
        //   await this.fetchDominantColor(this.assetId)
        // ).dominant_color;
        }
        this.setImageCaptions(this.assetId, artworkDetails);
        this.showPage("main-content-view");
        let image_url = this.getFifeCropUrl(artworkDetails.image.url, this.artworkImg);
        await this.loadImageToElement(image_url, this.artworkImg);
        this.artworkImg.classList.remove("hide");
        document.getElementById("poem-view-section-background").style.backgroundImage = "url(" + this.artworkImg.src + ")";
        document.getElementById("artwork-cover-background").style.backgroundImage = "url(" + this.artworkImg.src + ")";
        await this.shareCardMaker.storeImageForShareable(this.assetId, artworkDetails.image.url);
    }
    async showMoreArtwork(assetId) {
        const clickedItem = document.querySelector(`#more-artworks [data-assetid="${assetId}"`);
        const previousClickedItem = clickedItem.parentNode.querySelector(".active");
        if (previousClickedItem) previousClickedItem.classList.remove("active");
        clickedItem.classList.add("active");
        const data = this.assetsMap.get(assetId);
        document.getElementById("more-artworks-title").innerText = data.title;
        if (data.creators.length > 0) document.getElementById("more-artworks-author").innerText = data.creators[0].title;
        else document.getElementById("more-artworks-author").innerText = "";
        document.getElementById("more-artworks-partner").innerText = data.partner;
        //
        // get dominat color when selecting
        if (!data.hasOwnProperty("dominantColor") || data["dominantColor"] == null) {
            let dColor = (await this.fetchDominantColor(assetId)).dominant_color;
            this.assetsMap.set(assetId, {
                ...this.assetsMap.get(assetId),
                dominantColor: dColor
            });
        }
        this.setDominantColor(this.assetsMap.get(assetId)["dominantColor"]);
        if (this.isMobilePortrait()) this.onSelectedNewArtwork();
    }
    setDominantColor(dominantColor) {
        this.dominantColor = dominantColor;
        const [hue, saturation, lightness] = $c3354a5852f3cef7$var$hexToHsl("#" + this.dominantColor);
        let rgbVals = $c3354a5852f3cef7$var$hslToRgb(hue, saturation, 25);
        let rgb = {
            r: rgbVals[0],
            g: rgbVals[1],
            b: rgbVals[2]
        };
        document.body.style.setProperty("--color-main", `hsl(${hue} ${saturation}% ${$c3354a5852f3cef7$var$LIGHTNESS})`);
        document.body.style.setProperty("--color-light", `hsl(${hue} ${saturation}% ${$c3354a5852f3cef7$var$LIGHTNESS} / ${$c3354a5852f3cef7$var$BACKGROUND_ALPHA})`);
        document.body.style.setProperty("--color-dark", `hsl(${hue} ${saturation}% ${$c3354a5852f3cef7$var$LIGHTNESS_BUTTON})`);
        document.body.style.setProperty("--color-medium", `hsl(${hue} ${saturation}% ${$c3354a5852f3cef7$var$LIGHTNESS_BUTTON} / ${$c3354a5852f3cef7$var$BACKGROUND_ALPHA} )`);
        document.getElementById("artwork-scrim-layer1").style.setProperty("--scrim-background", `linear-gradient(180deg,
        rgba(${rgb.r}, ${rgb.g}, ${rgb.b},  .2 ) 20%,
        rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0 ) 40%,
        rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0 ) 60%,
        rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, .4 ) 80%)
      `);
        if (this.stampAmpersand) {
            this.stampAmpersand.setAttribute("fill", `hsl(${hue} ${saturation}% ${$c3354a5852f3cef7$var$LIGHTNESS})`);
            this.stampAmpersandMobile.setAttribute("fill", `hsl(${hue} ${saturation}% ${$c3354a5852f3cef7$var$LIGHTNESS})`);
        }
    }
    loadImages(container, width = 150, height = 150) {
        const imgList = container.querySelectorAll("[data-src]");
        for (const img of imgList){
            const src = img.getAttribute("data-src");
            if (src) {
                const fifeResizedUrl = src.replace("s1200", `h${height}-c-w${width}`);
                if (height !== 0 && width !== 0) {
                    const imgToLoad = new Image();
                    imgToLoad.crossOrigin = "anonymous";
                    imgToLoad.onload = ()=>{
                        img.style.backgroundImage = `url('${fifeResizedUrl}')`;
                        img.classList.add("loaded");
                        img.setAttribute("data-src", "");
                    };
                    imgToLoad.src = fifeResizedUrl;
                }
            }
        }
    }
    async getAllAssets() {
        try {
            const url = `${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/getAllAssets`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (!response.ok) {
                const message = response.status;
                throw new Error(message);
            } else {
                let responseData = await response.json();
                return responseData.assets;
            }
        } catch (err) {
            return {
                error: "could not get assets",
                type: err.name
            };
        }
    }
    //------- Page changes
    showPage(id) {
        this.prevPage = document.querySelector(".page.active");
        this.prevPage.classList.remove("active");
        this.currPage = document.getElementById(id);
        this.currPage.classList.add("active");
        if (this.currPage.id == "more-artworks") {
            this.prevPage.classList.add("flipped");
            this.currPage.classList.add("flipped");
        } else if (this.currPage.id == "artwork-cover") {
            this.prevPage.classList.add("flipped");
            this.currPage.classList.add("flipped");
            document.getElementById("main-content-view").classList.add("hidden");
        } else if (this.prevPage.id == "artwork-cover" && this.currPage.id == "main-content-view") {
            this.prevPage.classList.remove("backside");
            this.prevPage.classList.remove("flipped");
            this.prevPage.classList.add("slide-page");
        } else {
            this.prevPage.classList.remove("flipped");
            this.currPage.classList.remove("flipped");
        }
        if (this.currPage.id == "main-content-view") this.currPage.classList.remove("hidden");
        if (this.currPage.id == "poem-view-page") {
            this.currPage.classList.remove("flipped");
            document.getElementById("artwork-cover").classList.add("backside");
            document.getElementById("artwork-cover").classList.remove("hidden");
        }
        // slide main page section
        if (this.currPage.classList.contains("slide-page") && this.prevPage.id == "main-content-view") {
            let selector = "#" + this.prevPage.id + " .page-content";
            let slideSection = document.querySelector(selector);
            slideSection.classList.add("slide-out");
            this.prevPage.classList.add("disabled");
        } else if (this.currPage.id == "main-content-view") {
            let selector = "#" + this.currPage.id + " .page-content";
            let slideSection = document.querySelector(selector);
            slideSection.classList.remove("slide-out");
            this.currPage.classList.remove("disabled");
        }
        if (this.prevPage.id == "more-artworks") {
            this.setDominantColor(this.dominantColor);
            let dColor = this.assetsMap.get(this.assetId)["dominantColor"];
            if (dColor != null) this.setDominantColor(dColor);
        }
    }
    //------- User Interactions
    onButtonClick(e) {
        const button = e.currentTarget;
        const buttonBounds = button.getBoundingClientRect();
        const posX = e.pageX - buttonBounds.left;
        const posY = e.pageY - buttonBounds.top;
        new (0, $edfmO.default)(button, posX, posY);
    }
    onMoreArtworksButtonClicked = (event)=>{
        // if(this.loadArtworksStatus == "error" || this.loadArtworksStatus == "notloaded"){
        //   console.log("try load art");
        // }
        if ($c3354a5852f3cef7$var$isCultureStudio && this.axl) {
            this.sendStudioAction("ma");
            return;
        }
        this.loadMoreArtworks();
        this.showPage("more-artworks");
        if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.TRACK, {
            action: "click more artworks"
        });
    };
    onToneInputKeyDown = async (event)=>{
        if (event.key) {
            if (event.key === "Enter") {
                this.toneInput.blur();
                if (!$fAX6M()) this.onGenerateButtonClicked();
            }
        }
    };
    onGenerateButtonClicked = async (event)=>{
        this.toneInput.blur();
        if (this.generatingPoem) return;
        this.generatingPoem = true;
        document.getElementById("poem-view-page").classList.remove("flipped");
        document.getElementById("artwork-cover").classList.remove("slide-page");
        document.getElementById("artwork-cover").classList.add("hidden");
        let buttonEl = this.generateButton;
        // start loading screen
        this.showPoemLoadingUI();
        this.toneWarning.classList.add("hidden");
        this.poemErrorMessage.classList.add("hidden");
        const assetId = this.assetId;
        const poemType = document.querySelector("#poem-type-selected-name").getAttribute("data-value");
        if (this.axl) {
            let value = this.toneInput.value.length == 0 ? 0 : 1;
            this.axl.sendMessage((0, $geL0V.default).ChildToHost.TRACK, {
                action: "click write a poem",
                label: poemType + "-" + this.assetId,
                value: value
            });
        }
        const artworkDetailsPromise = this.fetchArtworkDetails(assetId);
        const tone = this.sanitizeUserInput(this.toneInput.value);
        const poemResponse = await this.fetchPoem(tone, poemType, assetId);
        // error handle
        if (poemResponse.hasOwnProperty("error")) {
            // handle error from user canceled
            if (poemResponse.type == "cancel") {
                buttonEl.classList.remove("spinner");
                this.generatingPoem = false;
                return;
            }
            // handle error with message
            let type = "default";
            if (poemResponse.hasOwnProperty("message")) {
                if (poemResponse.message == "inputSafety") {
                    buttonEl.classList.remove("spinner");
                    this.toneWarning.classList.remove("hidden");
                    this.closePoemLoadingUI();
                    this.generatingPoem = false;
                    return;
                }
            }
            if (poemResponse.type == "AbortError") type = "generic";
            this.handlePoemFetchError(buttonEl, type);
            this.generatingPoem = false;
            return;
        }
        // response received
        const { poem: poem, uuid: uuid } = poemResponse;
        const { creators: creators, title: title, partner: partner } = await artworkDetailsPromise;
        this.updateAttribution(title);
        this.poemCleaned = this.getCleanedPoemText(poem);
        this.poem.innerHTML = this.poemCleaned.replace(/\n/g, "<br>");
        document.getElementById("poem-view-page").classList.remove("shared-view", "flipped");
        this.showPage("poem-view-page");
        this.closePoemLoadingUI();
        buttonEl.classList.remove("spinner");
        this.uuid = uuid;
        this.generatingPoem = false;
    };
    showPoemLoadingUI() {
        const poemLoadingText = document.querySelector("#poem-type-selected-name").getAttribute("data-loading-text");
        let attribution = document.getElementById("loading-poem-text");
        attribution.innerText = poemLoadingText;
        document.getElementById("poem-select-section").classList.add("loading");
        document.getElementById("loading-poem-spinner").classList.add("spinner");
    }
    closePoemLoadingUI() {
        document.getElementById("poem-select-section").classList.remove("loading");
        setTimeout(()=>{
            document.getElementById("loading-poem-spinner").classList.remove("spinner");
        }, 500);
    }
    cancelPoemLoading() {
        // abort call
        if (this.poemSignal) this.poemSignal.abort("cancel");
        // close ui
        this.closePoemLoadingUI();
    }
    showMessage(type, timeout) {
        this.poemErrorMessage.setAttribute("data-type", type);
        this.poemErrorMessage.classList.remove("hidden");
        if (timeout) setTimeout((function() {
            this.poemErrorMessage.classList.add("hidden");
        }).bind(this), timeout);
    }
    handlePoemFetchError(buttonEl, type = "default") {
        this.closePoemLoadingUI();
        buttonEl.classList.remove("spinner");
        this.showMessage(type, 5000);
    }
    onBackToEditButtonClicked = async (event)=>{
        this.poem.innerHTML = "";
        this.showPage("main-content-view");
    };
    updateAttribution(title) {
        let attributions = document.querySelectorAll(".poem-attribution");
        attributions.forEach((item, i)=>{
            let attributionParts = [];
            var template = item.getAttribute("data-attribution-no-tone");
            attributionParts.push(title);
            for (const item of attributionParts)template = template.replace("{}", `${item}`);
            item.innerText = template;
        });
    }
    getCleanedPoemText(poem) {
        let poemCleaned = poem.replace(/Sure.*/, "").replace(/Here is a.*/, "").trim(); // Remove Bard saying "Sure, here is ..."
        // poemCleaned = poemCleaned.replaceAll("*", "");
        poemCleaned = poemCleaned.replace(/[`~@#$%^&*_+={}\[\]|<>]/gm, "");
        // poemCleaned.replace(/\n/g, "<br>");
        return poemCleaned;
    }
    onShareButtonClicked = async (event)=>{
        if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.TRACK, {
            action: "click share poem",
            label: this.assetId
        });
        const urlParams = {
            assetId: this.assetId,
            uuid: this.uuid
        };
        if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.SET_URL_PARAMS, urlParams);
        let partners = document.querySelectorAll(".caption-partner");
        let authors = document.querySelectorAll(".caption-artist");
        let partner = partners.length > 0 ? partners[0].innerText : null;
        let author = authors.length > 0 ? authors[0].innerText : "unknown";
        let studioShareString = partner ? "I just created this Poem Postcard in my Culture Studio: inspired by " + author + " from " + partner + ". Check it out then create your own: " : "I just created this Poem Postcard in my Culture Studio.  Check it out then create your own: ";
        // This ends up in the email *subject*
        const shareText = $c3354a5852f3cef7$var$isCultureStudio ? studioShareString : "You've Received a Poem Postcard";
        // This ends up in the email *body*
        const shareTitle = $c3354a5852f3cef7$var$isCultureStudio ? studioShareString : "Read your Poem Postcard on Google Arts & Culture: ";
        if ((0, $geL0V.default).can["shareFiles"]) {
            let shareImg = this.shareCardMaker.makeShareableCard(this.dominantColor, this.assetId).split(",")[1];
            this.axl.sendMessage((0, $geL0V.default).ChildToHost.SHARE, {
                title: shareTitle,
                // title: shareUrl,
                text: shareText
            });
        } else if (this.axl) this.axl.sendMessage((0, $geL0V.default).ChildToHost.SHARE, {
            title: shareTitle,
            // title: shareUrl,
            text: shareText
        });
    // testing
    // let shareImg = this.shareCardMaker.makeShareableCard(this.dominantColor,this.assetId);
    // this.shareCardMaker.downloadCard();
    };
    // Propagate the asset ID and the poem itself.
    savePoem(e) {
        e.stopPropagation();
        if ($c3354a5852f3cef7$var$isCultureStudio && this.axl) {
            const urlParams = {
                assetId: this.assetId,
                uuid: this.uuid
            };
            this.axl.sendMessage((0, $geL0V.default).ChildToHost.SET_URL_PARAMS, urlParams);
            this.sendStudioAction("sc", {
                "t": this.poemCleaned,
                "a": this.assetId
            });
        }
    }
    //------- Poem Generation
    fetchPoem = async (mood, poemType, assetId)=>{
        if ($c3354a5852f3cef7$var$CS_DEBUG) return {
            poem: "The stars are swirling,\nThe sun is fiery,\nThe moon is a smiley face.\n\nVan Gogh, you were a genius,\nYour art is amazing,\nIt makes me laugh and it makes me think.\n\nThank you for sharing your vision,\nWith the world,\nWe are all grateful."
        };
        this.poemSignal = new AbortController();
        const timer = setTimeout((function() {
            this.poemSignal.abort();
        }).bind(this), 30000);
        const url = `${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/poemv3`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    word: mood,
                    poemType: poemType,
                    assetId: assetId
                }),
                signal: this.poemSignal.signal //AbortSignal.timeout(30*1000)
            });
            clearTimeout(timer);
            const jsonData = await response.json();
            return jsonData;
        } catch (err) {
            let type = err.name;
            clearTimeout(timer);
            if (this.poemSignal.signal.aborted) {
                if (this.poemSignal.signal.reason == "cancel") type = "cancel";
            }
            return {
                error: "could not get poem",
                type: type
            };
        }
    };
    async fetchAllColors() {
        let keysList = [
            ...this.assetsMap.keys()
        ];
        const response = await fetch(`${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/dominant-colors`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(keysList)
        });
        const jsonData = await response.json();
        keysList.forEach((assetId, i)=>{
            this.assetsMap.set(assetId, {
                ...this.assetsMap.get(assetId),
                dominantColor: jsonData["dominant_colors"][assetId]
            });
        });
        return jsonData;
    }
    //------- Asset data
    async fetchArtworkDetails(assetId) {
        const existingData = this.assetsMap.get(assetId);
        if (existingData != undefined) return existingData;
        const response = await fetch(`${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/og/${assetId}`);
        const jsonData = await response.json();
        jsonData["dominantColor"] = null;
        this.assetsMap.set(assetId, jsonData);
        return jsonData;
    }
    fetchAssets = async (assetIds)=>{
        try {
            const response = await fetch(`${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/getAssetsData`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    assetIds: assetIds
                }),
                signal: AbortSignal.timeout(30000)
            });
            const jsonData = await response.json();
            return jsonData;
        } catch (err) {
            return {
                error: "assets data load failed",
                type: err.name
            };
        }
    };
    async fetchDominantColor(assetId) {
        const response = await fetch(`${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/dominant-color`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                assetId: assetId
            })
        });
        const jsonData = await response.json();
        return jsonData;
    }
    async getPoem(uuid) {
        try {
            const response = await fetch(`${window.location.origin + (window.location.pathname === "/" ? "" : window.location.pathname)}/getPoem`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "uuid": uuid
                }),
                signal: AbortSignal.timeout(30000)
            });
            const jsonData = await response.json();
            return jsonData.data;
        } catch (err) {
            return {
                error: "could not get shared poem",
                type: err.name
            };
        }
    }
    //----- Show shared view
    createShareablePostcard = async (poemData, restricted = false)=>{
        try {
            let uuid = poemData.uuid;
            let poemJson = await this.getPoem(uuid);
            if (poemJson.hasOwnProperty("error")) return;
            this.poemCleaned = poemJson.poem;
            this.poem.innerHTML = poemJson.poem.replace(/\n/g, "<br>");
            this.updateAttribution(poemJson.title);
        } catch (err) {
            return;
        }
        if (this.isMobilePortrait()) {
            this.showPage("poem-view-page");
            this.showPage("artwork-cover");
        } else this.showPage("poem-view-page");
        document.getElementById("artwork-cover").classList.add("shared-view");
        document.getElementById("poem-view-page").classList.add("shared-view");
        if (restricted) {
            document.getElementById("artwork-cover").classList.add("restricted");
            document.getElementById("poem-view-page").classList.add("restricted");
        }
    };
    sendStudioAction(command, params = {}) {
        params["c"] = command;
        this.axl.sendMessage((0, $geL0V.default).ChildToHost.STUDIO_ACTION, params);
    }
}
const $c3354a5852f3cef7$var$hexToHsl = (hex)=>{
    // See https://stackoverflow.com/questions/3732046/how-do-you-get-the-hue-of-a-xxxxxx-colour
    var r = parseInt(hex.substr(1, 2), 16); // Grab the hex representation of red (chars 1-2) and convert to decimal (base 10).
    var g = parseInt(hex.substr(3, 2), 16);
    var b = parseInt(hex.substr(5, 2), 16);
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [
        360 * h,
        100 * s,
        100 * l
    ];
};
const $c3354a5852f3cef7$var$hslToRgb = (h, s, l)=>{
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
};

});
parcelRequire.register("edfmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58e33291dc1ae80$export$2e2bcd8739ae039);
const $a58e33291dc1ae80$var$GRID_SIZE = 20;
const $a58e33291dc1ae80$var$SQUARE_SIZE = 1;
const $a58e33291dc1ae80$var$ANIMATION_DURATION = 500;
class $a58e33291dc1ae80$export$2e2bcd8739ae039 {
    constructor(el, left, top){
        this.$container = document.createElement("div");
        this.$container.classList.add("canvas-container");
        this.$canvas = document.createElement("canvas");
        this.context = this.$canvas.getContext("2d");
        this.color = el.getAttribute("data-ripple-color") || "#ffffff";
        const elBounds = el.getBoundingClientRect();
        this.canvasWidth = elBounds.width;
        this.canvasHeight = elBounds.height;
        this.$canvas.width = this.canvasWidth;
        this.$canvas.height = this.canvasHeight;
        this.canvasMaxSize = Math.max(this.canvasWidth, this.canvasHeight);
        this.rippleCenterX = left;
        this.rippleCenterY = top;
        this.$container.appendChild(this.$canvas);
        el.appendChild(this.$container);
        this.squares = [];
        this.initDate = new Date().getTime();
        this.isRippleComplete = false;
        this.init();
        this.draw();
    }
    init() {
        for(let x = 0; x < this.canvasWidth / $a58e33291dc1ae80$var$SQUARE_SIZE; x++)for(let y = 0; y < this.canvasHeight / $a58e33291dc1ae80$var$SQUARE_SIZE; y++){
            const posX = x * $a58e33291dc1ae80$var$SQUARE_SIZE;
            const posY = y * $a58e33291dc1ae80$var$SQUARE_SIZE;
            const centerX = posX + $a58e33291dc1ae80$var$SQUARE_SIZE * 0.5;
            const centerY = posY + $a58e33291dc1ae80$var$SQUARE_SIZE * 0.5;
            if (Math.pow(this.rippleCenterX - centerX, 2) + Math.pow(this.rippleCenterY - centerY, 2) < Math.pow(this.canvasMaxSize, 2)) this.squares.push(new $a58e33291dc1ae80$var$Square(this.context, posX, posY));
        }
        window.requestAnimationFrame(this.draw.bind(this));
    }
    draw() {
        if (this.isRippleComplete) return;
        this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        const newDate = new Date().getTime();
        const currentDate = newDate - this.initDate;
        this.context.fillStyle = this.color;
        let isOver = true;
        for (const square of this.squares){
            square.draw(currentDate, this.rippleCenterX, this.rippleCenterY);
            if (!square.isAnimationFinished) isOver = false;
        }
        this.isRippleComplete = isOver;
        if (isOver) this.$container.remove();
        window.requestAnimationFrame(this.draw.bind(this));
    }
}
class $a58e33291dc1ae80$var$Square {
    constructor(context, x, y){
        this.context = context;
        this.x = x;
        this.y = y;
        this.isAnimationFinished = false;
        this.alpha = Math.random() * 0.2;
    }
    draw(date, rippleCenterX, rippleCenterY) {
        if (this.isAnimationFinished) return;
        const distanceFromCenter = Math.sqrt(Math.pow(this.x - rippleCenterX, 2) + Math.pow(this.y - rippleCenterY, 2));
        const delay = distanceFromCenter * 0.7;
        const timeWithDelay = date - delay;
        const scale = timeWithDelay < 0 ? 0 : Math.min(1, Math.max(0, 1 - timeWithDelay / $a58e33291dc1ae80$var$ANIMATION_DURATION));
        const scaledSize = $a58e33291dc1ae80$var$SQUARE_SIZE * scale;
        this.context.globalAlpha = this.alpha;
        this.context.fillRect(this.x + ($a58e33291dc1ae80$var$SQUARE_SIZE - scaledSize) * 0.5, this.y + ($a58e33291dc1ae80$var$SQUARE_SIZE - scaledSize) * 0.5, scaledSize, scaledSize);
        if (timeWithDelay > 0 && scale === 0) this.isAnimationFinished = true;
    }
}

});

parcelRequire.register("aJPda", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d15d4d748a65be8$export$2e2bcd8739ae039);
class $7d15d4d748a65be8$export$2e2bcd8739ae039 {
    constructor(){
        this.scale = Math.ceil(window.devicePixelRatio);
        this.postcardW = 500 * this.scale;
        this.postcardH = 330 * this.scale;
        this.canvas = document.createElement("canvas");
        this.canvas.width = this.postcardW;
        this.canvas.height = this.postcardH;
        this.context = this.canvas.getContext("2d");
        this.context.imageSmoothingEnabled = false;
        this.stamp = new Image();
        this.stamp.src = "/poetic-postcard/images/stamp_card.svg";
    }
    async storeImageForShareable(assetId, url) {
        let imageW = Math.ceil(this.postcardW / 2);
        let imageH = this.postcardH;
        url += `=w${imageW}-h${imageH}-dc`;
        this.assetIdStored = null;
        this.img = new Image();
        this.img.crossOrigin = "anonymous";
        return new Promise((resolve, reject)=>{
            this.img.onload = ()=>resolve();
            this.img.onerror = reject;
            this.img.src = url;
        });
    }
    makeShareableCard(dominantColor, assetId) {
        this.img.src;
        // get colors
        const colorMain = "#" + dominantColor; //document.body.style.getPropertyValue("--color-main");
        // clear rect
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.fillStyle = "#ffffff";
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.globalAlpha = 0.25;
        this.context.fillStyle = colorMain;
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawClip(20, 20, 50);
        this.context.globalAlpha = 1.0;
        this.context.fillStyle = "#ffffff";
        this.context.fillRect(20, 20, this.canvas.width - 20, this.canvas.height - 20);
        this.drawClip(40, 40, 40);
        // draw background color
        this.context.fillStyle = colorMain;
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        // draw stamp
        let x = this.canvas.width - 60 * this.scale;
        let y = 70 * this.scale;
        let w = this.stamp.width * .35 * this.scale;
        let h = this.stamp.height * .35 * this.scale;
        let angle = 5 * (Math.PI / 180);
        this.context.save();
        this.context.globalAlpha = 0.65;
        this.context.translate(x, y);
        this.context.rotate(angle);
        this.context.drawImage(this.stamp, -w / 2, -h / 2, w, h);
        this.context.restore();
        // draw image
        this.context.drawImage(this.img, 0, 0, this.img.width, this.img.height);
        // draw lines
        x = this.img.width + 20 * this.scale;
        y = 40 * this.scale;
        w = 130 * this.scale;
        h = 30 * this.scale;
        this.drawLineBox(x, y, w, h);
        w *= 1.15;
        y += 100 * this.scale;
        h /= 2;
        let totalLines = 3 + Math.floor(Math.random() * 3);
        for(let i = 0; i < totalLines; i++){
            let offsetW = (Math.random() * 40 - 20) * this.scale;
            this.drawLineBox(x, y, w + offsetW, h);
            y += h * 2;
        }
        return this.canvas.toDataURL();
    }
    drawClip(x, y, radius) {
        let width = this.canvas.width - x * 2;
        let height = this.canvas.height - y * 2;
        this.context.beginPath();
        this.context.moveTo(x + radius, y);
        this.context.lineTo(x + width - radius, y);
        this.context.quadraticCurveTo(x + width, y, x + width, y + radius);
        this.context.lineTo(x + width, y + height - radius);
        this.context.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        this.context.lineTo(x + radius, y + height);
        this.context.quadraticCurveTo(x, y + height, x, y + height - radius);
        this.context.lineTo(x, y + radius);
        this.context.quadraticCurveTo(x, y, x + radius, y);
        this.context.closePath();
        this.context.clip();
    }
    drawLineBox(x, y, w, h) {
        this.context.globalAlpha = 0.5;
        this.context.fillStyle = "#ffffff";
        this.context.beginPath();
        this.context.roundRect(x, y, w, h, 4 * this.scale);
        this.context.fill();
        this.context.globalAlpha = 1.0;
    }
    downloadCard() {
        let dt = this.canvas.toDataURL("image/png");
        let link = document.createElement("a");
        link.href = dt;
        link.download = "poempostcard.png";
        link.click();
    }
}

});

parcelRequire.register("fAX6M", function(module, exports) {
"use strict";
module.exports = $b5a8117fb009006e$var$isMobile;
module.exports.isMobile = $b5a8117fb009006e$var$isMobile;
module.exports.default = $b5a8117fb009006e$var$isMobile;
const $b5a8117fb009006e$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $b5a8117fb009006e$var$notMobileRE = /CrOS/;
const $b5a8117fb009006e$var$tabletRE = /android|ipad|playbook|silk/i;
function $b5a8117fb009006e$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") ua = ua.headers["user-agent"];
    if (typeof ua !== "string") return false;
    let result = $b5a8117fb009006e$var$mobileRE.test(ua) && !$b5a8117fb009006e$var$notMobileRE.test(ua) || !!opts.tablet && $b5a8117fb009006e$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) result = true;
    return result;
}

});



//# sourceMappingURL=restricted.f9e0b304.js.map
